import { YStack, XStack, Text } from 'tamagui'
import type { ReferenceSlide as ReferenceSlideType } from '../../../content/decks/types'
import { SlideContainer, SlideInner, getAccentColor, parseLinkedText } from './shared'

export function ReferenceSlide({ slide }: { slide: ReferenceSlideType }) {
  const accentColor = getAccentColor(slide.accent)
  const midpoint = Math.ceil(slide.sections.length / 2)
  const col1 = slide.sections.slice(0, midpoint)
  const col2 = slide.sections.slice(midpoint)

  const renderColumn = (sections: typeof slide.sections) => (
    <YStack flex={1} minWidth={280} gap="$4">
      {sections.map((section, i) => (
        <YStack key={i} gap="$2">
          <Text
            fontFamily="$mono"
            fontWeight="600"
            color={accentColor}
            textTransform="uppercase"
            letterSpacing={1}
            style={{ fontSize: 'clamp(9px, 1vw, 13px)' }}
          >
            {parseLinkedText(section.heading, accentColor)}
          </Text>
          <YStack gap="$1" paddingLeft="$2" borderLeftWidth={2} borderLeftColor={`${accentColor}40`}>
            {section.items.map((item, j) => (
              <Text
                key={j}
                fontFamily="$body"
                color="$textSecondary"
                style={{ fontSize: 'clamp(10px, 1.1vw, 14px)', lineHeight: '1.4em' }}
              >
                {parseLinkedText(item)}
              </Text>
            ))}
          </YStack>
        </YStack>
      ))}
    </YStack>
  )

  return (
    <SlideContainer>
      <SlideInner style={{ padding: 'clamp(20px, 3vw, 48px)' }}>
        <Text
          fontFamily="$heading"
          fontWeight="700"
          color={accentColor}
          style={{ fontSize: 'clamp(20px, 2.5vw, 36px)', lineHeight: '1.2em' }}
        >
          {slide.headline}
        </Text>
        <XStack gap="$6" marginTop="$3" style={{ flexWrap: 'wrap' }}>
          {renderColumn(col1)}
          {renderColumn(col2)}
        </XStack>
        {slide.footer && (
          <Text
            fontFamily="$mono"
            color="$textMuted"
            marginTop="$3"
            style={{ fontSize: 'clamp(8px, 0.9vw, 11px)' }}
          >
            {parseLinkedText(slide.footer)}
          </Text>
        )}
      </SlideInner>
    </SlideContainer>
  )
}
